'use client';

import { useEffect, useState } from 'react';

const TIMES = [
  { label: '12:00  AM', value: '00:00' },
  { label: '1:00  AM', value: '01:00' },
  { label: '2:00  AM', value: '02:00' },
  { label: '3:00  AM', value: '03:00' },
  { label: '4:00  AM', value: '04:00' },
  { label: '5:00  AM', value: '05:00' },
  { label: '6:00  AM', value: '06:00' },
  { label: '7:00  AM', value: '07:00' },
  { label: '8:00  AM', value: '08:00' },
  { label: '9:00  AM', value: '09:00' },
  { label: '10:00  AM', value: '10:00' },
  { label: '11:00  AM', value: '11:00' },
  { label: '12:00  PM', value: '12:00' },
  { label: '1:00  PM', value: '13:00' },
  { label: '2:00  PM', value: '14:00' },
  { label: '3:00  PM', value: '15:00' },
  { label: '4:00  PM', value: '16:00' },
  { label: '5:00  PM', value: '17:00' },
  { label: '6:00  PM', value: '18:00' },
  { label: '7:00  PM', value: '19:00' },
  { label: '8:00  PM', value: '20:00' },
  { label: '9:00  PM', value: '21:00' },
  { label: '10:00  PM', value: '22:00' },
  { label: '11:00  PM', value: '23:00' },
];

export default function TimeSelectBottomModal({
  currentSelectedTime,
  timeType,
  setTimeType,
  onSelectTime,
}: {
  currentSelectedTime: string;
  timeType: 'start' | 'end' | undefined;
  setTimeType: React.Dispatch<React.SetStateAction<'start' | 'end' | undefined>>;
  onSelectTime: (time: string, timeType: 'start' | 'end') => void;
}) {
  const [visible, setVisible] = useState(false);
  const [fadeType, setFadeType] = useState<'in' | 'out'>('in');

  useEffect(() => {
    if (!timeType) {
      setFadeType('out');
      setTimeout(() => {
        setVisible(false);
      }, 200);
    } else {
      setVisible(true);
      setFadeType('in');

      const isNotHidden = document.body.style.overflowY !== 'hidden';
      if (isNotHidden) {
        document.body.style.overflowY = 'hidden';
      }

      return () => {
        if (isNotHidden) document.body.style.overflowY = 'auto';
      };
    }
  }, [timeType]);

  useEffect(() => {
    if (!visible) return;

    const $timeSelectBottomModal = document.getElementById('time-select-bottom-modal');

    const timesList = timeType === 'start' ? TIMES : TIMES.slice(1);
    const currentSelectedTimeIndex = timesList.findIndex((time) => time.value === currentSelectedTime);
    $timeSelectBottomModal?.scrollTo({
      top: (currentSelectedTimeIndex - 2.5) * 56,
      behavior: 'smooth',
    });
  }, [visible]);

  if (!visible) {
    return null;
  }

  return (
    <>
      <div
        className={`fixed w-full max-w-480pxr top-0 z-[100] h-dvh overflow-hidden bg-custom-black/60 flex items-center justify-center ${
          fadeType === 'in' ? 'animate-[fadeIn_300ms_ease-in-out]' : 'animate-[fadeOut_200ms_ease-in-out]'
        }`}
        onClick={() => {
          setTimeType(undefined);
        }}
      ></div>
      <div
        className={`fixed w-full max-w-480pxr bottom-0 h-360pxr z-[100] rounded-t-16pxr overflow-hidden ${
          fadeType === 'in'
            ? 'animate-[slideInFromBottom_300ms_ease-in-out]'
            : 'animate-[slideOutToBottom_200ms_ease-in-out]'
        }`}
      >
        <div className='relative h-360pxr rounded-t-16pxr bg-white'>
          <div className='h-24pxr absolute top-0 w-full max-w-480pxr bg-gradient-to-b from-white to-white/0 z-10'></div>
          <div id='time-select-bottom-modal' className='absolute top-0 overflow-y-scroll h-360pxr'>
            {(timeType === 'start' ? TIMES : TIMES.slice(1)).map((time) => (
              <button
                key={'time-option_' + time.value}
                className={`w-full text-center border-t first:border-t-0 border-gray-200 bg-white py-18pxr px-16pxr h-56pxr ${
                  currentSelectedTime === time.value ? 'button-16-b text-point-400' : 'button-16-m text-gray-800'
                }`}
                onClick={() => {
                  onSelectTime(time.value, timeType as 'start' | 'end');
                  setTimeType(undefined);
                }}
              >
                {time.value}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
